<template>
    <DsButton v-if="!isDetailOpen" @click="loadDetailedResults()" class="pp-ticket-check-results-detail__draw-detail"
        >NAČÍST PODROBNÉ VÝSLEDKY</DsButton
    >
    <template v-else>
        <h4 class="pp-ticket-check-results-detail__subheading">{{ drawDateText }}</h4>

        <PpDrawNumbersRychla6
            class="pp-ticket-check-results-detail__draw-detail"
            v-if="lottery === Lottery.rychla6"
            :numbers="drawResults.numbers"
        />
        <PpDrawNumbers
            v-else
            :lottery="lottery"
            :numbers="drawResults.numbers"
            :sort-by-draw="true"
            class="pp-ticket-check-results-detail__draw-detail"
        />
    </template>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import PpDrawNumbers from "@/lotteries/product-page/components/results/pp-draw-numbers.vue";
import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";
import { DrawResults } from "@/lotteries/services/model/draw-results";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { fetchResultsById } from "@/lotteries/services/draw-info/api";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import PpDrawNumbersRychla6 from "../results/pp-draw-numbers-rychla-6.vue";

const props = defineProps<{
    lottery: Lottery;
    drawId: number;
}>();

let drawResults: DrawResults = null;
let drawDateText: string = null;
const isDetailOpen = ref(false);

async function loadDetailedResults() {
    try {
        drawResults = await fetchResultsById(props.lottery, props.drawId);
        drawDateText = `Slosováno 
            ${DateTimeUtils.formatLongDateWithWeekday(new Date(drawResults.drawDate))},
            ${drawResults.week}. týden`;

        isDetailOpen.value = true;
    } catch {
        showAlert({ title: "Nepodařilo se načíst podrobné výsledky" });
        return;
    }
}
</script>
